import React from 'react';
import GridCellBoolean from './GridCellBoolean';

export interface IColumn {
  title: string;
  field: string;
  show: boolean;
  alwaysVisible: boolean;
  filter?: 'boolean' | 'numeric' | 'text' | 'date' | undefined;
  minWidth?: number;
  minGridWidth?: number;
  locked?: boolean;
  width?: string | number;
  noColumnMenu?: boolean;
  notFilterable?: boolean;
  twoFilterCriteria?: boolean;
  cell?: React.FC<any>;
  orderIndex?: number;
}

export const columns: IColumn[] = [
  {
    field: 'rank',
    title: 'Rank',
    width: '110px',
    filter: 'numeric',
    show: true,
    alwaysVisible: true,
    orderIndex: 1,
  },
  {
    field: 'location.name',
    title: 'Location',
    width: '130px',
    notFilterable: true,
    show: true,
    alwaysVisible: true,
    orderIndex: 2,
  },
  {
    field: 'title',
    title: 'Message Title',
    width: '160px',
    show: true,
    alwaysVisible: true,
    orderIndex: 3,
  },
  {
    field: 'id',
    title: 'Message ID',
    width: '145px',
    show: true,
    alwaysVisible: true,
    orderIndex: 4,
  },
  {
    field: 'messageType',
    title: 'Message Type',
    width: '160px',
    show: true,
    alwaysVisible: true,
    orderIndex: 5,
  },
  {
    field: 'status',
    title: 'Status',
    width: '115px',
    show: true,
    alwaysVisible: false,
    orderIndex: 6,
  },
  {
    field: 'beginDate',
    title: 'Begin Date',
    width: '145px',
    filter: 'date',
    twoFilterCriteria: true,
    show: true,
    alwaysVisible: true,
    orderIndex: 7,
  },
  {
    field: 'endDate',
    title: 'End Date',
    width: '130px',
    filter: 'date',
    twoFilterCriteria: true,
    show: true,
    alwaysVisible: true,
    orderIndex: 8,
  },
  {
    field: 'primaryKey',
    title: 'Unique ID',
    width: '140px',
    show: true,
    alwaysVisible: true,
    orderIndex: 9,
  },
  {
    field: 'isRequired',
    title: 'Required',
    width: '130px',
    filter: 'boolean',
    cell: GridCellBoolean,
    show: true,
    alwaysVisible: true,
    orderIndex: 10,
  },
  {
    field: 'isOverflowAllowed',
    title: 'Overflow',
    width: '130px',
    filter: 'boolean',
    show: true,
    alwaysVisible: false,
    orderIndex: 11,
  },
  {
    field: 'forceHardcopy',
    title: 'Hardcopy',
    width: '135px',
    filter: 'boolean',
    show: true,
    alwaysVisible: false,
    orderIndex: 12,
  },
  {
    field: 'hideInEcare',
    title: 'Hide in eCare',
    width: '135px',
    filter: 'boolean',
    show: true,
    alwaysVisible: false,
    orderIndex: 13,
  },
  {
    field: 'sysPrinCount',
    title: 'Sys Prins',
    width: '135px',
    filter: 'numeric',
    show: true,
    alwaysVisible: false,
    orderIndex: 14,
  },
  {
    field: 'creator',
    title: 'Creator',
    width: '120px',
    show: true,
    alwaysVisible: false,
    orderIndex: 15,
  },
  {
    field: 'createDate',
    title: 'Create Date',
    width: '110px',
    filter: 'date',
    twoFilterCriteria: true,
    show: true,
    alwaysVisible: false,
    orderIndex: 16,
  },
  {
    field: 'approver',
    title: 'Approver',
    width: '135px',
    show: true,
    alwaysVisible: false,
    orderIndex: 17,
  },
  {
    field: 'approvalDate',
    title: 'Approval Date',
    width: '160px',
    filter: 'date',
    twoFilterCriteria: true,
    show: true,
    alwaysVisible: false,
    orderIndex: 18,
  },
  {
    field: 'graphicId',
    title: 'Graphic ID',
    width: '135px',
    show: true,
    alwaysVisible: false,
    orderIndex: 19,
  },
];
